module.exports = __webpack_public_path__ + "img/icon-1-2.8fc4eca2.png";